window.addEventListener('DOMContentLoaded',() => {
	
	const settings = {
		organizationId: "01", // botiPT: 01, QDBPT: 02, botiCOL: 03, botiUS: 04, NativaUS: 05
		hostname : window.location.hostname,
		platform : '',
		utmSource : '',
		utmMedium : '',
		utmCampaign: '',
		utmContent:'',
		referrer : document.referrer,
		uri : window.location.pathname,
		name : document.title,
		email : '',
		customerId : '',
		sessionId: '',
		userIdentity: ''
	}
	
	const isMobile = () => {
		settings.platform = 'desktop';
		if(/iPhone|Mobile|Android/i.test(navigator.userAgent)){ 
			settings.platform = 'mobile';
		}
	};

	const uuid = () => {
		return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
	}

	const setCookie = (cName, cValue, expDays) => {
			let date = new Date();
			date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
			const expires = 'expires=' + date.toUTCString();
			document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
	};
	
	const getCookies = (cName) => {
		let cookie = {};
		document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
		});
		return cookie[cName];
	};

	const sanitization = (dirty) => {
		const clean = dirty.replaceAll(/[&\\,:\']/g,'');
		return clean;
	}
	
	const handlerCookie = (cookieName, cookieTime) => {
		let uuidCookie = '';
		if(getCookies(cookieName) === undefined || getCookies(cookieName) === '' ) {
			uuidCookie = uuid();
			setCookie(cookieName, uuidCookie, cookieTime)
		}else {
			uuidCookie = getCookies(cookieName)
		}
		return uuidCookie;
	}

	const handlerUtm = () => {
		let utms = [];
		let searchUrl = window.location.search.replace('?','');
		if(searchUrl !== '' && searchUrl.includes('utm_')) {
			searchUrl = searchUrl.split('&');
			searchUrl = searchUrl.map((utm) => {
				const KeyValue = utm.split('=')
				
				const utmSwitch = (key, value) => ({
					source: key === 'utm_source' ? value : '',
					medium: key === 'utm_medium' ? value : '',
					campaign: key === 'utm_campaign' ? value : '',
					content: key === 'utm_content' ? value : ''
				});
				const newArr = utmSwitch(KeyValue[0], KeyValue[1]);
	
				Object.entries(newArr).filter((current, index, arr) => {
					if(current[1] !== '') {
						utms[current[0]] = current[1];
					}
				})
	
			})
			
			if(utms.campaign !== undefined) {
				settings.utmCampaign = sanitization(utms.campaign);
			}
			settings.utmSource = utms.source;
			settings.utmMedium = utms.medium;
			settings.utmContent = utms.content;
			setCookie('utm_source', utms.source, 'session');
			setCookie('utm_medium', utms.medium, 'session');
			setCookie('utm_campaign', settings.utmCampaign, 'session');
			setCookie('utm_content', utms.content, 'session');
		}else {
			settings.utmCampaign = getCookies('utm_campaign');
			settings.utmSource = getCookies('utm_source');
			settings.utmMedium = getCookies('utm_medium');
			settings.utmContent = getCookies('utm_content');
		}
	}

	const sendingData = () => {
		
		
		const data ={
			"hostname": settings.hostname,
			"priority": "NORMAL",
			"alertType": "INFO",
			"organizationId": settings.organizationId,
			"platform": settings.platform,
			"title": "PAGEVIEW",
			"text": "PAGEVIEW",
			"tags": `name:${sanitization(settings.name)},organizationId:${settings.organizationId},type:LANDING,referrer:${sanitization(settings.referrer)},utmSource:${settings.utmSource},utmMedium:${settings.utmMedium},utmCampaign:${settings.utmCampaign},utmContent:${settings.utmContent},uri:${settings.uri},customerId:${settings.customerId},email:${settings.email},sessionId:${settings.sessionId},userIdentity:${settings.userIdentity}`
		}
		
		fetch('https://event-serverless.prd.internacional.grupoboticario.digital/events', {
			method: 'POST', 
			headers: {
				'x-api-key': '4w7hvjOB4f8r7F5who9fy9eZegQ6zE9B5jpP1nj3',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(response => response.json()) 
		.catch(err => console.error(err));
			
	}

	const init = () => {
		isMobile();
		settings.sessionId = handlerCookie('sessionId', 'session');
		settings.userIdentity = handlerCookie('userIdentity', 365);
		handlerUtm();
		sendingData();
	};
	init();

});